export default "__VITE_ASSET__0886358c__"